import { lobbyRoomParser } from './utils/lobbyRoomInboundUtils';
export const UPDATE_LOBBY_ROOM_PAYLOAD_DEFINITION = {
    isRawParam: true,
    definitionParts: [{ name: 'lobbyRoom', parser: lobbyRoomParser }]
};
